import React from 'react';
import { Box, Button, Card, CardContent, Chip, Typography, Checkbox } from '@mui/material';
import PlanFeature from './PlanFeature';
import { Plan } from './types';
import { displayMoney } from '../../utilities/displayValues';

interface PlanCardProps {
    plan: Plan;
    isSelected: boolean;
    onSelect: (planId: string) => void;
}

const PlanCard: React.FC<PlanCardProps> = ({ plan, isSelected, onSelect }) => {
    return (
        <Card
            sx={{
                height: 380,
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                overflow: 'visible',
                border: (theme) => isSelected ? `2px solid ${theme.palette.primary.main}` : '1px solid #E5E7EB',
                cursor: 'pointer',
                bgcolor: isSelected ? 'rgba(2, 33, 74, 0.05)' : 'background.paper',
            }}
            onClick={() => onSelect(String(plan.cod_plan))}
        >

            <CardContent
                sx={{
                    pt: 2,
                    pb: 2,
                    px: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', mb: 2 }}>
                    <Typography variant="h5" component="h5">
                        {plan.name_plan}
                    </Typography>
                </Box>

                {/* <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                    {plan.description}
                </Typography> */}
                {plan.original_price === 0 && (<br />)}

                {plan.original_price > 0 && (
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Typography variant="body2" component="span" sx={{ textDecoration: 'line-through', color: 'text.secondary', mr: 1 }}>
                            De R$ {plan.original_price.toFixed(2)}
                        </Typography>
                    </Box>
                )}

                <Box sx={{ display: 'flex', alignItems: 'baseline', mb: 1, justifyContent: 'center' }}>
                    <Typography component="span" sx={{ fontSize: '0.9rem', fontWeight: 'medium', mr: 0.5 }}>
                        R$
                    </Typography>
                    <Typography variant="h3" component="span" sx={{ fontWeight: 'bold', lineHeight: 1 }}>
                        {displayMoney(plan.current_price).split(',')[0]}
                    </Typography>
                    <Typography component="span" sx={{ fontSize: '1.2rem', fontWeight: 'medium', mr: 0.5 }}>
                        ,{displayMoney(plan.current_price).split(',')[1]}
                    </Typography>
                    <Typography component="span" sx={{ fontSize: '0.9rem', color: 'text.secondary' }}>
                        /mês*
                    </Typography>
                </Box>
                {plan.total_price === 0 && (<br />)}
                {plan.total_price > 0 && (
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'center' }}>
                        <Typography variant="body2" component="span" sx={{ color: 'text.secondary', mr: 1 }}>
                            Totalizando R$
                        </Typography>
                        <Typography variant="body2" component="span" sx={{ color: 'text.secondary', mr: 1, fontWeight: 'bold' }}>
                            {displayMoney(plan.total_price)}
                        </Typography>
                    </Box>
                )}
                {plan.discount_percent === 0 && (<br />)}
                {plan.discount_percent > 0 && (
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, justifyContent: 'flex-end' }}>
                        <Chip
                            label={`ECONOMIZE ${plan.discount_percent}%`}
                            size="small"
                            sx={{
                                bgcolor: 'rgba(16, 31, 51, 0.1)',
                                color: 'primary.main',
                                fontWeight: 'bold',
                                fontSize: '0.7rem',
                            }}
                        />
                    </Box>
                )}

                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
                    {plan.caption_plan}
                </Typography>

                {isSelected && (
                    <Button
                        variant="contained"
                        fullWidth
                        color="primary"
                        sx={{
                            my: 2,
                            py: 1.5,
                            bgcolor: 'primary.main',
                            color: 'white',
                            border: 'none',
                            borderColor: 'primary.main',
                        }}
                    >
                        Plano selecionado
                    </Button>
                )}
            </CardContent>
        </Card>
    );
};

export default PlanCard;